import { PaperworkCopyFormFieldsCheckboxName, PaperworkFieldName } from '../paperworkConstants';

export interface CopyPaperworkFieldsCheckbox {
  fieldNames: PaperworkFieldName[];
  defaultChecked: boolean;
  fieldNamesToCopyFromCurrentBooking?: PaperworkFieldName[];
}

export type CopyPaperworkFieldsCheckboxCollection = Map<
  PaperworkCopyFormFieldsCheckboxName,
  CopyPaperworkFieldsCheckbox
>;

export const COPY_PAPERWORK_FIELDS_CHECKBOXES: CopyPaperworkFieldsCheckboxCollection = new Map([
  [
    PaperworkCopyFormFieldsCheckboxName.ADDRESS,
    {
      fieldNames: [
        PaperworkFieldName.PATIENT_ADDRESS_STREET,
        PaperworkFieldName.PATIENT_ADDRESS_STREET_TWO,
        PaperworkFieldName.PATIENT_ADDRESS_CITY,
        PaperworkFieldName.PATIENT_ADDRESS_STATE,
        PaperworkFieldName.PATIENT_ADDRESS_ZIP,
      ],
      defaultChecked: true,
    },
  ],
  [
    PaperworkCopyFormFieldsCheckboxName.PHARMACY,
    {
      fieldNames: [PaperworkFieldName.PREFERRED_PHARMACY],
      defaultChecked: true,
    },
  ],
  [
    PaperworkCopyFormFieldsCheckboxName.PHYSICIAN,
    {
      fieldNames: [PaperworkFieldName.PRIMARY_CARE_PHYSICIAN],
      defaultChecked: true,
    },
  ],
  [
    PaperworkCopyFormFieldsCheckboxName.EMERGENCY_CONTACT,
    {
      fieldNames: [
        PaperworkFieldName.EMERGENCY_CONTACT_FIRST_NAME,
        PaperworkFieldName.EMERGENCY_CONTACT_MIDDLE_NAME,
        PaperworkFieldName.EMERGENCY_CONTACT_LAST_NAME,
        PaperworkFieldName.EMERGENCY_CONTACT_PHONE,
      ],
      defaultChecked: true,
    },
  ],
  [
    PaperworkCopyFormFieldsCheckboxName.INSURANCE,
    {
      fieldNames: [
        PaperworkFieldName.PRIMARY_INSURANCE_COMPANY,
        PaperworkFieldName.PRIMARY_INSURANCE_PLAN_NAME,
        PaperworkFieldName.PRIMARY_MEMBER_ID,
        PaperworkFieldName.PRIMARY_GROUP_NUMBER,
        PaperworkFieldName.PRIMARY_POLICY_HOLDER_FIRST_NAME,
        PaperworkFieldName.PRIMARY_POLICY_HOLDER_MIDDLE_NAME,
        PaperworkFieldName.PRIMARY_POLICY_HOLDER_LAST_NAME,
        PaperworkFieldName.PRIMARY_POLICY_HOLDER_BIRTH_SEX,
        PaperworkFieldName.PRIMARY_POLICY_HOLDER_BIRTH_DATE,
      ],
      defaultChecked: true,
    },
  ],
  [
    PaperworkCopyFormFieldsCheckboxName.GUARDIAN_ADDRESS,
    {
      fieldNames: [
        PaperworkFieldName.GUARDIAN_ADDRESS,
        PaperworkFieldName.GUARDIAN_ADDRESS_TWO,
        PaperworkFieldName.GUARDIAN_CITY,
        PaperworkFieldName.GUARDIAN_STATE,
        PaperworkFieldName.GUARDIAN_ZIP,
      ],
      defaultChecked: true,
      fieldNamesToCopyFromCurrentBooking: [
        PaperworkFieldName.PATIENT_ADDRESS_STREET,
        PaperworkFieldName.PATIENT_ADDRESS_STREET_TWO,
        PaperworkFieldName.PATIENT_ADDRESS_CITY,
        PaperworkFieldName.PATIENT_ADDRESS_STATE,
        PaperworkFieldName.PATIENT_ADDRESS_ZIP,
      ],
    },
  ],
  [
    PaperworkCopyFormFieldsCheckboxName.GUARANTOR_INFO,
    {
      fieldNames: [
        PaperworkFieldName.GUARANTOR_FIRST_NAME,
        PaperworkFieldName.GUARANTOR_LAST_NAME,
        PaperworkFieldName.GUARANTOR_BIRTH_DATE,
        PaperworkFieldName.GUARANTOR_PHONE,
        PaperworkFieldName.GUARANTOR_RELATIONSHIP,
      ],
      defaultChecked: true,
      fieldNamesToCopyFromCurrentBooking: [
        PaperworkFieldName.GUARDIAN_FIRST_NAME,
        PaperworkFieldName.GUARDIAN_LAST_NAME,
        PaperworkFieldName.GUARDIAN_BIRTH_DATE,
        PaperworkFieldName.GUARDIAN_PHONE,
        PaperworkFieldName.GUARDIAN_RELATIONSHIP_TO_PATIENT,
      ],
    },
  ],
]);
